var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "edit_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.879c-.563 0-1.102.223-1.5.621L9 12l-1 4 4-1 9.5-9.5A2.121 2.121 0 0 0 20 1.879Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTEgNEg0QzMuNDY5NTcgNCAyLjk2MDg2IDQuMjEwNzEgMi41ODU3OSA0LjU4NTc5QzIuMjEwNzEgNC45NjA4NiAyIDUuNDY5NTcgMiA2VjIwQzIgMjAuNTMwNCAyLjIxMDcxIDIxLjAzOTEgMi41ODU3OSAyMS40MTQyQzIuOTYwODYgMjEuNzg5MyAzLjQ2OTU3IDIyIDQgMjJIMThDMTguNTMwNCAyMiAxOS4wMzkxIDIxLjc4OTMgMTkuNDE0MiAyMS40MTQyQzE5Ljc4OTMgMjEuMDM5MSAyMCAyMC41MzA0IDIwIDIwVjEzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMjAgMS44Nzg2NkMxOS40Mzc0IDEuODc4NjYgMTguODk3OCAyLjEwMjE2IDE4LjUgMi40OTk5OEw5IDEyTDggMTZMMTIgMTVMMjEuNSA1LjQ5OTk4QzIxLjg5NzggNS4xMDIxNiAyMi4xMjEzIDQuNTYyNTkgMjIuMTIxMyAzLjk5OTk4QzIyLjEyMTMgMy40MzczNyAyMS44OTc4IDIuODk3ODEgMjEuNSAyLjQ5OTk4QzIxLjEwMjIgMi4xMDIxNiAyMC41NjI2IDEuODc4NjYgMjAgMS44Nzg2NloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";